import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { MessageService } from '@services';

@Component({
  selector: 'bo-message-system',
  templateUrl: './message-system.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class MessageSystemComponent {
  expand = input(false);
  protected messageService = inject(MessageService);
}
